import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AboutComponent } from './about/about.component';
import { LanguageComponent } from './language/language.component';
import { Language } from 'angular-l10n';
import { AppBarPortalsService } from '../services/common/app-bar-portals-service.module';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {

  visible = true;
  @Output() open: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() logout: EventEmitter<any> = new EventEmitter();
  @Language() lang;
  constructor(public dialog: MatDialog, public appBarPortals: AppBarPortalsService) { }

  ngOnInit() {
  }
  logOut() {
    this.logout.emit(false);
  }

  toggleSidenav(object: any): void {
    this.visible = !this.visible;
    if (this.visible) {
      this.open.emit(true);
    } else {
      this.close.emit(false);
    }
  }

  openAboutDialog() {
    const dialogRef = this.dialog.open(AboutComponent, {
      height: '50%',
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openLanguageDialog() {
    const dialogRef = this.dialog.open(LanguageComponent, {
      height: '50%',
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }


}
